import { createFileRoute } from '@tanstack/react-router'
import { CreateWizard } from '@/features/vsl/wizard/CreateWizard'
import { VslProjectsSection } from '@/features/vsl/runs/VslProjectsSection'

// Single page: the create form (everything visible at once) on top, and the table
// of already-made creatives below.
function VslNewPage() {
  return (
    <div className="flex flex-col gap-8">
      <CreateWizard />
      <div className="border-t border-border pt-6">
        <VslProjectsSection />
      </div>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/vsl/new')({
  component: VslNewPage,
})
